import { cn } from '../../lib/utils';

const tones = {
  brand: 'bg-brand/[0.12] text-brand border-line-brand',
  neutral: 'bg-white/[0.06] text-content-muted border-line',
  success: 'bg-success/[0.12] text-success border-success/25',
  solid: 'bg-brand text-ink-950 border-transparent',
};

export default function Badge({ tone = 'brand', className, children, ...props }) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full border px-3 py-1',
        'text-xs font-bold uppercase tracking-[0.08em]',
        tones[tone],
        className,
      )}
      {...props}
    >
      {children}
    </span>
  );
}
